import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UnidadOrganizacional } from '../models/UnidadOrganizacional';

@Injectable({
  providedIn: 'root'
})
export class UnidadOrganizacionalService {

  private getDepartamentosJerarquicoURL = environment.apiUrl + "uo/j"
  private getDepartamentosURL = environment.apiUrl + "uo/departamentos"
  private departamentoURL = environment.apiUrl + "uo"
  private getDepartamentosUsuarioActualURL = environment.apiUrl + "uo/usuario/uo"

  constructor(
    private http: HttpClient
  ) { }

  /**
   *
   * @returns @deprecated
   * @description Se usa en listado simple de autocompplete de departamentos
   */
  getDepartamentosJerarquico(): Observable<UnidadOrganizacional[]> {
    return this.http.get<UnidadOrganizacional[]>(this.getDepartamentosJerarquicoURL)
  }
  getDepartamentosTree(): Observable<UnidadOrganizacional[]> {
    return this.http.get<UnidadOrganizacional>(this.departamentoURL+"/uoj").pipe(
      map((val)=>{
        var tmpArray = []
        tmpArray.push(val)
        return tmpArray
      })
    )
  }
  getAllDepartamentosTree(): Observable<UnidadOrganizacional[]> {
    return this.http.get<UnidadOrganizacional>(environment.apiUrl + "uo/uoj1").pipe(
      map((val)=>{
        var tmpArray = []
        tmpArray.push(val)
        return tmpArray
      })
    )
  }

  // Public endpoint for authenticated non-admin users to retrieve full tree
  getUoTodosPublic(): Observable<UnidadOrganizacional[]> {
    return this.http.get<UnidadOrganizacional>(environment.apiUrl + "uo/uojPublic").pipe(
      map((val)=>{
        var tmpArray = []
        tmpArray.push(val)
        return tmpArray
      })
    )
  }

  listDepartamentos(): Observable<UnidadOrganizacional[]> {
    return this.http.get<UnidadOrganizacional[]>(this.getDepartamentosURL)
  }

  /**
   * Devuelve los destinatarios (servidores públicos) asociados a un departamento
   */
  getDestinatariosByDepartamento(id: string | number) {
    return this.http.get<any[]>(this.getDepartamentosURL.replace('departamentos', '') + 'led/' + id);
  }

  getDepartamentosUsuarioActual(): Observable<UnidadOrganizacional[]> {
    return this.http.get<UnidadOrganizacional[]>(this.getDepartamentosUsuarioActualURL);
  }
}
